import { Component, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';
import { UntypedFormGroup } from '@angular/forms';
import { FileUploadSuccess } from '@shared/interfaces/project/file-upload-success.interface';
import { PhCropperComponent } from '@shared/components/ph-cropper/ph-cropper.component';
import { PhUploadComponent } from '@shared/components/ph-upload/ph-upload.component';
import { Response } from '@shared/models/response.model';
import { ProjectService } from '../../../../project.service';
import { BaseComponent } from '@shared/components/base.component';
import * as moment from 'moment';
import { Config } from '@shared/config';
import { Project } from '@shared/models/project.model';
import { ActivatedRoute } from '@angular/router';
import { Coordinates } from '@shared/interfaces/project/coordinates.interface';
import OpenStreetMapWithMarkerComponent from '@layouts/default/components/open-street-map-with-marker/open-street-map-with-marker.component';

@Component({
  selector: 'app-photos',
  templateUrl: './photos.component.html',
  styleUrls: ['./photos.component.scss'],
})
export class PhotosComponent extends BaseComponent implements OnInit {
  @ViewChild('openStreetMap', { static: true }) openStreetMap: OpenStreetMapWithMarkerComponent;
  @Input() correctForm: UntypedFormGroup = null;
  @Input() correctFormDesc: UntypedFormGroup = null;
  @ViewChild('beforeImg', { static: true }) beforeImg: PhUploadComponent;
  @ViewChild('afterImg', { static: true }) afterImg: PhUploadComponent;
  @ViewChild('leaveTrashImg', { static: true }) leaveTrashImg: PhUploadComponent;
  @ViewChild('additionalImg1', { static: true }) additionalImg1: PhUploadComponent;
  @ViewChild('additionalImg2', { static: true }) additionalImg2: PhUploadComponent;
  @ViewChild('additionalImg3', { static: true }) additionalImg3: PhUploadComponent;
  @ViewChild('additionalImg4', { static: true }) additionalImg4: PhUploadComponent;
  @ViewChild('additionalImg5', { static: true }) additionalImg5: PhUploadComponent;
  @ViewChild('additionalImg6', { static: true }) additionalImg6: PhUploadComponent;
  @ViewChild('additionalImg7', { static: true }) additionalImg7: PhUploadComponent;
  @ViewChild('additionalImg8', { static: true }) additionalImg8: PhUploadComponent;
  @ViewChild('additionalImg9', { static: true }) additionalImg9: PhUploadComponent;
  @ViewChild('additionalImg10', { static: true }) additionalImg10: PhUploadComponent;
  @ViewChild('additionalImg11', { static: true }) additionalImg11: PhUploadComponent;
  @ViewChild('additionalImg12', { static: true }) additionalImg12: PhUploadComponent;
  @ViewChild('additionalImg13', { static: true }) additionalImg13: PhUploadComponent;
  @ViewChild('additionalImg14', { static: true }) additionalImg14: PhUploadComponent;
  @ViewChild('additionalImg15', { static: true }) additionalImg15: PhUploadComponent;
  @ViewChild('additionalImg16', { static: true }) additionalImg16: PhUploadComponent;
  @ViewChild('additionalImg17', { static: true }) additionalImg17: PhUploadComponent;
  @ViewChild('additionalImg18', { static: true }) additionalImg18: PhUploadComponent;
  @ViewChild('additionalImg19', { static: true }) additionalImg19: PhUploadComponent;
  @ViewChild('additionalImg20', { static: true }) additionalImg20: PhUploadComponent;
  @ViewChild('additionalImg21', { static: true }) additionalImg21: PhUploadComponent;
  @ViewChild('additionalImg22', { static: true }) additionalImg22: PhUploadComponent;
  @ViewChild('additionalImg23', { static: true }) additionalImg23: PhUploadComponent;
  @ViewChild('additionalImg24', { static: true }) additionalImg24: PhUploadComponent;
  @ViewChild('additionalImg25', { static: true }) additionalImg25: PhUploadComponent;
  @ViewChild('additionalImg26', { static: true }) additionalImg26: PhUploadComponent;
  @ViewChild('additionalImg27', { static: true }) additionalImg27: PhUploadComponent;
  @ViewChild('additionalImg28', { static: true }) additionalImg28: PhUploadComponent;
  @ViewChild('additionalImg29', { static: true }) additionalImg29: PhUploadComponent;
  @ViewChild('additionalImg30', { static: true }) additionalImg30: PhUploadComponent;
  @ViewChild('additionalImg31', { static: true }) additionalImg31: PhUploadComponent;
  @ViewChild('additionalImg32', { static: true }) additionalImg32: PhUploadComponent;
  @ViewChild('additionalImg33', { static: true }) additionalImg33: PhUploadComponent;
  @ViewChild('additionalImg34', { static: true }) additionalImg34: PhUploadComponent;
  @ViewChild('additionalImg35', { static: true }) additionalImg35: PhUploadComponent;
  @ViewChild('additionalImg36', { static: true }) additionalImg36: PhUploadComponent;
  @ViewChild('additionalImg37', { static: true }) additionalImg37: PhUploadComponent;
  @ViewChild('additionalImg38', { static: true }) additionalImg38: PhUploadComponent;
  @ViewChild('additionalImg39', { static: true }) additionalImg39: PhUploadComponent;
  @ViewChild('additionalImg41', { static: true }) additionalImg40: PhUploadComponent;
  @ViewChild('additionalImg42', { static: true }) additionalImg41: PhUploadComponent;
  @ViewChild('additionalImg43', { static: true }) additionalImg42: PhUploadComponent;
  @ViewChild('additionalImg44', { static: true }) additionalImg43: PhUploadComponent;
  @ViewChild('additionalImg45', { static: true }) additionalImg44: PhUploadComponent;
  @ViewChild('additionalImg46', { static: true }) additionalImg45: PhUploadComponent;
  @ViewChild('additionalImg47', { static: true }) additionalImg46: PhUploadComponent;
  @ViewChild('additionalImg48', { static: true }) additionalImg47: PhUploadComponent;
  @ViewChild('additionalImg49', { static: true }) additionalImg48: PhUploadComponent;
  @ViewChild('additionalImg50', { static: true }) additionalImg49: PhUploadComponent;
  @ViewChild('additionalImg50', { static: true }) additionalImg50: PhUploadComponent;
  @Output() newProjectCreateData: EventEmitter<any> = new EventEmitter();
  @Output() imagesData: EventEmitter<any> = new EventEmitter();
  @ViewChild('phCropper', { static: true }) phCropper: PhCropperComponent;
  datesBank: { beforeImg: string; afterImg: string; leaveTrashImg: string } = {
    beforeImg: null,
    afterImg: null,
    leaveTrashImg: null,
  };
  photosChangeMapOnClick: boolean = true;
  photosMarkerDraggable: boolean = true;
  mapCordsBuffor: { coords: { lng: number; lat: number } } = null;
  primaryIndex: number = 5;
  showNextButton: boolean = true;

  displayAfterImageHelpModal: boolean = false;
  displayBeforeImageHelpModal: boolean = false;
  displayDisposedImageHelpModal: boolean = false;

  constructor(public projectService: ProjectService, public route: ActivatedRoute) {
    super();
  }

  ngOnInit() {
    this.getCoordinatesFromIp();
    this.activeInput(5);
  }

  activeInput(index: number) {
    return index > this.primaryIndex;
  }

  showNextInput() {
    this.primaryIndex += 1;
    if (this.primaryIndex === 50) {
      this.showNextButton = false;
    }
  }

  getCoordinatesFromIp() {
    const subData = this.route.data.subscribe((data: { editProject: Response<Project> }) => {
      if (data.editProject && data.editProject.data.latitude && data.editProject.data.longitude) {
        this.openStreetMap.updatePosition(+data.editProject.data.latitude, +data.editProject.data.longitude);
      } else {
        const subGetCoordinates = this.projectService
          .getCoordinates()
          .subscribe((el: Response<Coordinates>) => {
            if (el.data && el.data.latitude && el.data.longitude) {
              this.openStreetMap.updatePosition(+el.data.latitude, +el.data.longitude);
            }
          }, this.onGetCoordinatesError.bind(this));
        this.someSubscriptions.add(subGetCoordinates);
      }
    });
    this.someSubscriptions.add(subData);
  }

  onGetCoordinatesError(error: Error) {
    this.toast.error(
      this.translate.instant('PROJECT.cant_get_coordinates'),
      this.translate.instant('PROJECT.project_error')
    );
  }

  findCorrectPhUpload(event) {
    this[event.name].fromCropper(event);
    if (this.mapCordsBuffor && this.mapCordsBuffor.coords.lat && this.mapCordsBuffor.coords.lng) {
      this.openStreetMap.updatePosition(this.mapCordsBuffor.coords.lat, this.mapCordsBuffor.coords.lng);
      this.mapCordsBuffor = null;
    }
    this.phCropper.closeModal();
  }

  addToCropper(event, cropperRequired: boolean = true) {
    if (cropperRequired) {
      this.phCropper.newImg(event);
    }
  }

  setProjectCreateData(event: FileUploadSuccess) {
    this.newProjectCreateData.emit(event);
  }

  setProjectMap(event: FileUploadSuccess) {
    if (!event.coordinates.latitude && !event.coordinates.longitude) {
      this.toast.warning(
        this.translate.instant('PROJECT.photo_not_have_cords'),
        this.translate.instant('PROJECT.project_error')
      );
    }
    this.mapCordsBuffor = {
      coords: {
        lat: event.coordinates.latitude,
        lng: event.coordinates.longitude,
      },
    };
  }

  setElementsFromImageTags(event: FileUploadSuccess, type?: string, phUploadElement?) {
    this.imagesData.emit(event);
    if (type && phUploadElement) {
      // const datesOlder: boolean = this.checkOlderDates(phUploadElement);
      const datesOlder: boolean = false;
      if (datesOlder) {
        this.toast.error(
          this.translate.instant('PROJECT.different_dates_on_photos'),
          this.translate.instant('PROJECT.project_error')
        );
        phUploadElement.loading = false;
        return;
      } else {
        phUploadElement.addCorrectlyImg();
        if (event.date || event.coordinates) {
          switch (type) {
            case 'map': {
              this.setProjectMap(event);
              break;
            }
            case 'date': {
              this.setProjectCreateData(event);
              break;
            }
          }
        }
      }
    }
  }

  checkOlderDates(phUploadElement) {
    this.datesBank[phUploadElement.name] = phUploadElement.uploadSavePack.date;

    let newestImg = null; // get one older date between -> afterImg || leaveTrashImg
    if (this.datesBank.afterImg && this.datesBank.leaveTrashImg) {
      const diffNewestImg = moment(this.datesBank.afterImg, Config.DATE_FORMAT_BACKEND).diff(
        moment(this.datesBank.leaveTrashImg, Config.DATE_FORMAT_BACKEND),
        'seconds'
      );
      newestImg = diffNewestImg < 0 ? this.datesBank.leaveTrashImg : this.datesBank.afterImg;
    } else if (this.datesBank.afterImg) {
      newestImg = this.datesBank.afterImg;
    } else if (this.datesBank.leaveTrashImg) {
      newestImg = this.datesBank.leaveTrashImg;
    } else {
      return false; // in this moment, user added only 'before' img. Images 'after'/'leaveTrash' are empty
    }

    if (this.datesBank.beforeImg && newestImg) {
      const different = moment(newestImg, Config.DATE_FORMAT_BACKEND).diff(
        moment(this.datesBank.beforeImg, Config.DATE_FORMAT_BACKEND),
        'seconds'
      );
      if (different < 0) {
        return true; // ERROR photo 'after'/'leaveTrash' is older then before
      }
    }
    return false; // all ok
  }

  catchMapError(message) {
    switch (message) {
      case Config.PHOTO_ERROR_NO_META:
        break;
      case Config.PHOTO_ERROR_NO_GPS:
        break;
      case Config.PHOTO_ERROR_WAS_MODIFIED:
        break;
    }
  }
}
